import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { Icon } from 'Components/frameworks/icon/Icon';
import { themes } from './PriceViewRate.themes';
type Props = {
  className?: string;
  label?: string;
  theme?: keyof typeof themes;
};
export const PriceViewRate = ({ className, label, theme, ...rest }: Props) => {
  const { thIcon, thRoot } = themes[theme];

  if (!label) {
    return null;
  }

  return (
    <span {...rest} className={classnames(thRoot, className)}>
      <Icon className={thIcon} name={ICONS.DATE} width="1em" />
      {label}
    </span>
  );
};
